<template>
  <el-cascader
    ref="cascader"
    class="w-300"
    v-model="val"
    :options="posts"
    :props="postsProps"
    :placeholder="placeholder"
    :show-all-levels="showAllLevels"
    :collapse-tags="collapseTags"
    :clearable="clearable"
    :filterable="filterable"
    :disabled="disabled"
    @change="handleChange"
  >
  </el-cascader>
</template>

<script>
import expertService from "@/global/service/expert";

export default {
  props: {
    value: {
      type: [Number, Array],
      default: () => []
    },
    field: {
      type: String,
      default: "id"
    },
    size: {
      type: String,
      default: "medium"
    },
    placeholder: {
      type: String,
      default: "请选择岗位方向"
    },
    showAllLevels: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    expandTrigger: {
      type: String,
      default: "hover"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    emitPath: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: null,
      posts: [],
      postsProps: {
        expandTrigger: this.expandTrigger,
        emitPath: this.emitPath,
        multiple: this.multiple,
        value: this.field,
        label: "name",
        children: "children"
      }
    };
  },
  created() {
    this.getData();
  },
  watch: {
    value: {
      handler(val) {
        this.val = val;
      },
      immediate: true
    },
    val(val) {
      this.$emit("update:value", val);
    }
  },
  methods: {
    getData() {
      expertService.expertIndustryJobs().then(res => {
        this.posts = res;
      });
    },
    handleChange(e) {
      if (this.emitPath) {
        e = e[e.length - 1];
      }
      let result;
      if (!this.multiple) {
        result = this.$refs.cascader.getCheckedNodes();
      } else {
        result = this.$refs.cascader.getCheckedNodes().filter(data => {
          return e.indexOf(data.value) >= 0;
        });
      }
      this.$emit("getNodes", result);
    },
    handleJobNode(nodes = []) {
      let jobs = nodes.map(data => {
        return {
          job_id: data.value,
          job_name: this.recursionParent(data).join(">>")
        };
      });
      if (!this.multiple) {
        jobs = jobs[0];
      }
      this.$emit("update:jobs", jobs);
    },
    recursionParent(data, result = []) {
      result.push(data.label);
      if (!data.parent) {
        return result;
      }
      return this.recursionParent(data.parent, result);
    }
  }
};
</script>
